export default "__VITE_ASSET__$HJWKK6u__"